import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash-es';
import { useParams } from 'react-router-dom';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons';

import { ShareButton } from '../share-button';
import { getShareViaFacebookSelector } from 'common/selectors/settings';
import { getBase64SharePathSelector } from '../selectors';

const shareViaFacebook = (params) => {
  window.FB.ui(
    {
      method: 'share',
      href: `${window.location.origin}/api/share?p=${params}`,
    },
    function (response) {}
  );
};

export const FacebookButton = () => {
  const getShareViaFacebook = useSelector(getShareViaFacebookSelector);
  const isFacebookSdkLoaded = get(getShareViaFacebook, 'loaded');
  const isShareViaFacebookEnabled = get(getShareViaFacebook, 'enabled');
  const params = useSelector(getBase64SharePathSelector(useParams()));
  const handleClick = () => shareViaFacebook(params);

  return (
    <ShareButton
      hidden={!isShareViaFacebookEnabled || !isFacebookSdkLoaded}
      dataE2e="facebook-button"
      onClick={handleClick}
      icon={faFacebookSquare}
      label="Facebook"
    />
  );
};
